import moment from 'moment';
import { DateFormat } from '../../../../../utils/date';

import texts from './texts.json';

const getColumns = ({
  actionsRenderCell,
  commentTextMap,
}) => (
  [
    {
      field: 'reason',
      headerName: texts.headers.report,
      quickSearch: true,
      flex: 20,
    },
    {
      field: 'comment',
      headerName: texts.headers.comment,
      flex: 20,
      valueGetter: ({ row }) => commentTextMap[row.commentId],
    },
    {
      field: 'reportedAt',
      headerName: texts.headers.reportedAt,
      flex: 8,
      type: 'datetime',
      valueGetter: ({ row }) => new Date(row.reportedAt),
      renderCell: ({ row }) => (
        moment(row.reportedAt).format(DateFormat.DATE_FORMAT_COMMA)
      ),
    },
    {
      field: 'reportedUsername',
      headerName: texts.headers.reportedUser,
      flex: 8,
    },
    {
      field: 'reportedByUsername',
      headerName: texts.headers.reporter,
      flex: 8,
    },
    {
      field: 'actions',
      headerName: texts.headers.actions,
      sortable: false,
      filterable: false,
      width: 400,
      renderCell: actionsRenderCell,
    },
  ]
);

export default getColumns;
